import CompensationDashboard from './components/CompensationDashboard'

function App() {
  return <CompensationDashboard />
}

export default App